module.exports = __webpack_public_path__ + "img/partly-cloudy-night.b75d90bd.svg";